import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api, { apiError } from "../lib/api";
import { Helper } from "../components/ui-bits";
import { toast } from "sonner";

export default function CompleteProfile() {
  const { user, setUser, loading } = useAuth();
  const [form, setForm] = useState({ company: "", role_title: "" });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/projects";

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [loading, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/profile", form);
      setUser(data);
      navigate(next);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  const field = (key, label, opts = {}) => (
    <div>
      <label className="text-sm font-medium text-[#0B1F3A]">{label}</label>
      <input type="text" required={!opts.optional} value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })}
        placeholder={opts.placeholder || ""}
        className="mt-1 w-full bg-white border border-[#0B1F3A]/20 rounded-md px-3 py-2.5 text-sm focus:ring-2 focus:ring-[#059669] focus:outline-none" data-testid={`profile-${key}-input`} />
      {opts.helper && <Helper>{opts.helper}</Helper>}
    </div>
  );

  return (
    <div className="max-w-md mx-auto px-4 py-14">
      <h1 className="font-serif text-3xl text-[#0B1F3A]">One last step</h1>
      <p className="text-sm text-[#475569] mt-1">Tell us who this project belongs to — it personalises your roadmaps and reports.</p>
      <form onSubmit={submit} className="space-y-3 mt-8">
        {field("company", "Company", { helper: "The organisation this project belongs to" })}
        {field("role_title", "Role / designation", { optional: true, helper: "e.g., Project Manager, EPC Head — optional" })}
        <button type="submit" disabled={busy} className="w-full bg-[#1D4ED8] text-white rounded-md py-3 font-medium text-sm hover:bg-[#1638A8] disabled:opacity-60" data-testid="profile-submit-btn">
          {busy ? "Saving…" : "Save & continue"}
        </button>
      </form>
      <button onClick={() => navigate(next)} className="mt-4 w-full text-sm text-[#475569] underline" data-testid="profile-skip-btn">
        Skip for now
      </button>
    </div>
  );
}
